<klt-section title="Market capitalisation">
  <div class="graph-box">
    <klt-graph
      [loading]="loading"
      height="480px"
      [options]="options"
      [titles]="titles"
      (filter)="runFilter($event)"
    >
    </klt-graph>
  </div>
</klt-section>
